export enum NavTransitionType {
  SLIDE = 'slide',
  NONE = ''
}
